export default {

  component: {
    jobAdList: {
      title: 'Açık iş pozisyonları',
      jobs: 'işler',
      noJobAds: 'Şu anda açık pozisyon yok.',
    },

    jobAdCard: {
      openUntil: date => `Şu tarihe kadar açık: ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Teşekkürler.',
      readyInfo: 'Başvurunuz alındı; işe alım birimi kısa süre içinde size geri dönüş yapacaktır.',
      luck: 'Bol şans!',
    },

    jobAdSeeYou: {
      title: 'Teşekkürler.',
      description: 'Başvurunuz kaydedildi ve başvuru işlemine daha sonra devam edebileceğiniz bir link gönderdik.',
    },

    unpublished: {
      title: 'Yayınlanmadı',
      info: 'İş ilanı henüz yayınlanmadı.',
    },
  },

  page: {
  },

}
